import { IGetProduce } from './types'

export const getProduceVars: IGetProduce = {
  state: {
    in: ['Unpublished', 'Published'],
  },
}
